class YotpoProductReviews extends HTMLElement {
  constructor () {
    super()

    this.attemptLoop = 0

    this.featureSource = this.querySelector('[data-yotpo-product-reviews-el="feature-source"]')

    this.summaryCount = this.querySelector('[data-yotpo-product-reviews-el="summary-count"]')
    this.summaryBars = this.querySelector('[data-yotpo-product-reviews-el="summary-bars"]')
    this.fitBar = this.querySelector('[data-yotpo-product-reviews-el="summary-fitbar"]')
    this.lengthBar = this.querySelector('[data-yotpo-product-reviews-el="summary-lengthbar"]')
    this.summaryType = this.querySelector('[data-yotpo-product-reviews-el="summary-type"]')
    this.summaryComment = this.querySelector('[data-yotpo-product-reviews-el="summary-comment"]')

    this.allReviewsLink = this.querySelector('[data-yotpo-product-reviews-el="all-reviews-link"]')
    this.detailsDrawer = this.querySelector('[data-yotpo-product-reviews-el="details-drawer"]')
    this.closeButton = this.querySelector('[data-yotpo-product-reviews-el="close-details"]')

    this.pageHeader = document.querySelector('header')

    if (this.featureSource.textContent.trim() !== '') {
      this.pullFeatured()
    } else {
      const loop = () => {
        setTimeout(() => {
          if (this.featureSource.textContent.trim() !== '') {
            this.pullFeatured()
          } else {
            this.attemptLoop += 1
            if (this.attemptLoop < 10) loop()
          }
        }, 500)
      }
      loop()
    }

    this.allReviewsLink.addEventListener('click', () => {
      this.pageHeader.style.zIndex = 2
      this.detailsDrawer.setAttribute('aria-hidden', false)
    })

    this.closeButton.addEventListener('click', () => {
      this.detailsDrawer.setAttribute('aria-hidden', true)
      this.pageHeader.style.zIndex = 10
    })

    this.detailsDrawer.addEventListener('click', (e) => {
      if (e.target.dataset.yotpoProductReviewsEl === 'details-drawer') {
        this.detailsDrawer.setAttribute('aria-hidden', true)
        this.pageHeader.style.zIndex = 10
      }
    })
  }

  pullFeatured () {
    const reviewCount = this.featureSource.querySelector('.yotpo-bottom-line-basic-text').textContent
    this.summaryCount.textContent = reviewCount

    const summaryBars = this.featureSource.querySelectorAll('.yotpo-header-container .yotpo-progress-bar')

    if (summaryBars.length > 0) {
      this.summaryBars.classList.remove('hidden')
      this.fitBar.innerHTML = summaryBars[0].innerHTML
      this.lengthBar.innerHTML = summaryBars[1].innerHTML
    }

    const reviews = this.featureSource.querySelectorAll('.yotpo-review')
    if (reviews.length > 0) {
      const reviewerType = reviews[0].querySelector('.yotpo-custom-questions-value').textContent
      if (reviewerType !== '') this.summaryType.textContent = reviewerType

      const reviewerComment = reviews[0].querySelector('.yotpo-review-content').textContent
      if (reviewerComment !== '') this.summaryComment.textContent = `"${reviewerComment}"`
    }

    this.classList.remove('hidden')
  }
}

customElements.define('yotpo-product-reviews', YotpoProductReviews)
